const SELECTORS = [
  '.grada-embed',
  '.twitter-tweet',
  '.instagram-media',
  '.tiktok-embed',
  '.fb-post',
].join(', ');

const SCRIPT_IDS = {
  x: 'grada-embed-x',
  instagram: 'grada-embed-instagram',
  tiktok: 'grada-embed-tiktok',
  facebook: 'grada-embed-facebook',
};

function articleRoot() {
  return document.querySelector('.article-details__content');
}

function loadScript(src, id) {
  const existing = document.getElementById(id);
  if (existing) {
    return existing.dataset.loaded === 'true'
      ? Promise.resolve()
      : new Promise((resolve, reject) => {
          existing.addEventListener('load', () => resolve(), { once: true });
          existing.addEventListener('error', reject, { once: true });
        });
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = true;
    script.onload = () => {
      script.dataset.loaded = 'true';
      resolve();
    };
    script.onerror = reject;
    document.body.appendChild(script);
  });
}

function hydrateX(root) {
  if (!root.querySelector('.twitter-tweet, [data-provider="x"]')) return;

  const process = () => window.twttr?.widgets?.load(root);

  if (window.twttr?.widgets?.load) {
    process();
    return;
  }

  loadScript('https://platform.twitter.com/widgets.js', SCRIPT_IDS.x).then(process).catch(() => {});
}

function hydrateInstagram(root) {
  if (!root.querySelector('.instagram-media, [data-provider="instagram"]')) return;

  const process = () => window.instgrm?.Embeds?.process();

  if (window.instgrm?.Embeds?.process) {
    process();
    return;
  }

  loadScript('https://www.instagram.com/embed.js', SCRIPT_IDS.instagram).then(process).catch(() => {});
}

function hydrateTikTok(root) {
  if (!root.querySelector('.tiktok-embed, [data-provider="tiktok"]')) return;

  const existing = document.getElementById(SCRIPT_IDS.tiktok);
  if (existing) existing.remove();

  loadScript('https://www.tiktok.com/embed.js', SCRIPT_IDS.tiktok).catch(() => {});
}

function ensureFbRoot() {
  if (document.getElementById('fb-root')) return;
  const root = document.createElement('div');
  root.id = 'fb-root';
  document.body.insertBefore(root, document.body.firstChild);
}

function hydrateFacebook(root) {
  if (!root.querySelector('.fb-post, [data-provider="facebook"]')) return;

  ensureFbRoot();

  if (window.FB?.XFBML?.parse) {
    window.FB.XFBML.parse(root);
    return;
  }

  const previousInit = window.fbAsyncInit;
  window.fbAsyncInit = function fbAsyncInit() {
    if (typeof previousInit === 'function') previousInit();
    window.FB.init({ xfbml: true, version: 'v21.0' });
    window.FB.XFBML.parse(root);
  };

  loadScript('https://connect.facebook.net/es_LA/sdk.js', SCRIPT_IDS.facebook).catch(() => {});
}

export function hydrateSocialEmbeds() {
  const root = articleRoot();
  if (!root || !root.querySelector(SELECTORS)) return;

  hydrateX(root);
  hydrateInstagram(root);
  hydrateTikTok(root);
  hydrateFacebook(root);
}

document.addEventListener('turbo:load', hydrateSocialEmbeds);
document.addEventListener('turbo:render', hydrateSocialEmbeds);
